export default __webpack_public_path__ + "06bcf1fd27ee9a5c8d5624671e2b4649.png";